import { OlympsConfigOlymp } from '@yandex-int/k-common';
import { Button, CertificateBanner, CERTIFICATE_LAYOUT, useIntl, useStaticUrls } from 'platform-components';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import ym from 'react-yandex-metrika';

interface Props {
    olympConfig?: OlympsConfigOlymp;
}

export const TeacherActiveParticipantCertBanner = ({ olympConfig }: Props) => {
    const { formatMessage } = useIntl();
    const history = useHistory();
    const { labPortfolio } = useStaticUrls();

    const i18n = (id: string) =>
        formatMessage({ id: `specCourse.lessonView.teacherActiveParticipantCertificateBanner.${id}` });

    const handleClick = useCallback(() => {
        ym('reachGoal', 'teacher_olymp_download_teacher_active_participant_certificate');

        history.push(labPortfolio);
    }, [history, labPortfolio]);

    const imageSrc = olympConfig?.teacher?.results?.banners?.activeParticipantCertificateBannerImgSrc || null;

    return (
        <CertificateBanner
            buttonProps={{
                view: Button.VIEW.ACTION,
            }}
            buttonText={i18n('goToPortfolio')}
            headerText={i18n('title')}
            imageSrc={imageSrc}
            layout={CERTIFICATE_LAYOUT.WIDE}
            onClick={handleClick}
            showButton={true}
            theme="yellow"
        />
    );
};
